import {z} from 'zod';
import {parseJsonCookie} from './parse-json-cookie.js';

export type AdbContextCookie = z.TypeOf<typeof AdbContextCookie>;

export const AdbContextCookie = z.object({
  customerUserId: z.string().optional(),
  customerPreferredLang: z.string().optional(),
  customerType: z.string().optional(),
  customerUUID: z.string().optional(),
});

export const adbContextCookieName = `smart-adb_context`;

export function parseAdbContextCookie(
  cookieData: string,
): AdbContextCookie | undefined {
  return parseJsonCookie({
    cookieData,
    cookieName: adbContextCookieName,
    schema: AdbContextCookie,
  });
}
